import { type JSX, useState } from 'react';
import Box from 'carbon-react/esm/components/box';
import {
  FlatTable,
  FlatTableHead,
  FlatTableBody,
  FlatTableRow,
  FlatTableHeader,
  FlatTableCell,
} from 'carbon-react/esm/components/flat-table';
import { useParams } from 'react-router-dom';
import Typography from 'carbon-react/esm/components/typography';
import TablePager from '../../../../pages/dsn-list/component/TablePager';
import Icon from 'carbon-react/esm/components/icon';
import { useQueryPayments } from '../../../../hooks/useQueryPayments';
import PreviewListComponent from '../../../../components/PreviewList';
import { parseQueryPaymentsResponse } from '../../../../utils/odataResponseHelper';

export default function PaiementsTab() {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const { instanceId: urlInstanceId } = useParams<{ instanceId: string }>();

  const queryResult = useQueryPayments(urlInstanceId, currentPage, pageSize);
  const paymentsResponse = parseQueryPaymentsResponse(queryResult);
  const payments = paymentsResponse.status === 'success' ? paymentsResponse.data.items : [];
  const totalCount = paymentsResponse.status === 'success' ? paymentsResponse.data.totalCount : 0;

  const handlePagination = (newPage: number, newPageSize: number | undefined) => {
    setCurrentPage(newPage);
    if (newPageSize) {
      setPageSize(newPageSize);
    }
  };

  if (queryResult.isLoading) {
    return <PreviewListComponent />;
  }

  const content: JSX.Element = (
    <div className="edi-list-table">
      <FlatTable
        colorTheme="light"
        hasOuterVerticalBorders={false}
        bottomBorderRadius="borderRadius000"
        marginBottom={1}
        isZebra
      >
        <FlatTableHead>
          <FlatTableRow horizontalBorderSize="medium">
            <FlatTableHeader px="2">Statut</FlatTableHeader>
            <FlatTableHeader px="2">N° de compte IBAN</FlatTableHeader>
            <FlatTableHeader px="2">Montant</FlatTableHeader>
          </FlatTableRow>
        </FlatTableHead>
        <FlatTableBody>
          {payments.length === 0 ? (
            <FlatTableRow>
              <FlatTableCell colspan={3} px="2">
                <Typography>Aucun paiement disponible pour cette déclaration.</Typography>
              </FlatTableCell>
            </FlatTableRow>
          ) : (
            payments.map(paiement => {
              let statusContent;
              if (paiement.Status === 'AcknowledgedByDestination') {
                statusContent = (
                  <span style={{ color: '#007e45' }}>
                    <Icon type="submitted" size="small" mr={1} />
                  </span>
                );
              } else if (
                paiement.Status === 'RedForbidden' ||
                paiement.Status === 'EdiRejectedByDestination'
              ) {
                statusContent = (
                  <span style={{ color: '#cb374a' }}>
                    <Icon type="cross_circle" size="small" mr={1} />
                  </span>
                );
              } else {
                statusContent = paiement.Status;
              }

              return (
                <FlatTableRow key={paiement.InstanceId}>
                  <FlatTableCell px="2">{statusContent}</FlatTableCell>
                  <FlatTableCell px="2">{paiement.Rib}</FlatTableCell>
                  <FlatTableCell px="2">{paiement.Montant}</FlatTableCell>
                </FlatTableRow>
              );
            })
          )}
        </FlatTableBody>
      </FlatTable>
      <TablePager
        totalRecords={totalCount}
        pageSize={pageSize}
        currentPage={currentPage}
        onPagination={(next, size) => handlePagination(next, size)}
        pageSizeSelectionOptions={[
          { id: '5', name: 5 },
          { id: '10', name: 10 },
          { id: '20', name: 20 },
          { id: '50', name: 50 },
        ]}
      />
    </div>
  );

  return (
    <Box height="100%" flex="1" borderRadius="borderRadius000" maxHeight="600px">
      {content}
    </Box>
  );
}
